import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_GET_LIST } from 'api/actionTypes';

export default async function getPartnerList({ state, apiClient }) {
  const partnerListStatePath = ['partners', 'list'];
  if (state.get(partnerListStatePath)) {
    return state.get(partnerListStatePath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_LIST,
    state: state,
    onSuccess(partnerList) {
      typeCheck('partnerList::Array', partnerList);
      state.set(partnerListStatePath, partnerList);
      return partnerList;
    },
  });
}
